var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 540,
    height: 437,
    viewBox: "0 0 540 437",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.19 0C104.19 0 203.524 62.3576 123.101 172.035C42.6776 281.711 84.097 386.93 102.062 432.163C102.238 433.682 539.015 432.885 539.725 433.089C540.435 433.292 539.564 1.10616 539.349 0.737041C539.851 0.885877 104.19 0 104.19 0Z",
    fill: "#857EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseLoginBg);
export default __webpack_public_path__ + "static/media/purchaseLoginBg.7be4cbb8709b78123718bccc83d72905.svg";
export { ForwardRef as ReactComponent };